import { 
    CREATE_ORDER, 
    CREATE_ORDER_SUCCEEDED, 
    PAY_ORDER, PAY_ORDER_SUCCEEDED, 
    GET_ORDER_DETAILS, 
    GET_ORDER_DETAILS_SUCCEEDED, 
    GET_ORDERS_LIST,
    GET_ORDERS_LIST_SUCCEEDED,
    UPDATE_ORDER,
    UPDATE_ORDER_SUCCEEDED,
    REDIRECT_TO_MOBIL_PAY} from "./types";


export const createOrder = (payload) => ({
    type: CREATE_ORDER,
    payload
})

export const createOrderSucceeded = (payload) => ({
    type: CREATE_ORDER_SUCCEEDED,
    payload
})

export const payOrder = (payload) => ({
    type: PAY_ORDER,
    payload
})

export const payOrderSucceeded = (payload) => ({
    type: PAY_ORDER_SUCCEEDED,
    payload
})

export const getOrderDetails = (payload) => ({
    type: GET_ORDER_DETAILS,
    payload
})

export const getOrderDetailsSucceeded = (payload) => ({
    type: GET_ORDER_DETAILS_SUCCEEDED,
    payload
})

export const getOrdersList = (payload) => ({
    type: GET_ORDERS_LIST,
    payload
})

export const getOrdersListSucceeded = (payload) => ({
    type: GET_ORDERS_LIST_SUCCEEDED,
    payload
})

export const updateOrder = (payload) => ({
    type: UPDATE_ORDER,
    payload
})

export const updateOrderSucceeded = (payload) => ({
    type: UPDATE_ORDER_SUCCEEDED,
    payload
})

export const redirectToMobilPay = (payload) => ({
    type: REDIRECT_TO_MOBIL_PAY,
    payload
})






// WEBPACK FOOTER //
// ./src/SHARED/actions/payment.actions.js